import { Button, TableComponent } from "components";
import InputSelect from "components/atoms/InputSelect";
import React, { Component } from "react";
import { PlusCircle } from "react-feather";
import { PageMode, UserLevel, UserRoles } from "utils/constant";

class Table extends Component {
  render() {
    const {
      data,
      changeMode,
      loading,
      onSearch,
      onEdit,
      onRemove,
      onPageChange,
      handleInputChange,
      values,
      onFilter
    } = this.props;

    return (
      <div className="dashboard-wrapper">
        <h1 className="title font-weight-bold">Manajemen Data Pengguna</h1>
        <div className="py-3">
          <div className="row">
            <div className="col">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "flex-end",
                  padding: "16px",
                  borderRadius: "10px",
                  backgroundColor: "#fbfafa",
                  border: "1px solid #ecedf0",
                  marginTop: "8px",
                  marginBottom: "24px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <InputSelect
                    label="Level"
                    name="level"
                    placeholder="Pilih"
                    data={[
                      { value: UserLevel.Fasyankes, label: "Fasyankes" },
                      { value: UserLevel.District, label: "Kabupaten/Kota" },
                      { value: UserLevel.Province, label: "Provinsi" },
                      { value: UserLevel.National, label: "Nasional/Pusat" },
                      { value: UserLevel.LabTier2, label: "Lab Tingkat 2" },
                      { value: UserLevel.LabTier3, label: "Lab Tingkat 3" },
                      { value: UserLevel.LabTier4, label: "Lab Tingkat 4" },
                      { value: UserLevel.LabTier5, label: "Lab Tingkat 5" },
                      { value: UserLevel.BKKInduk, label: "BKK Induk" },
                      { value: UserLevel.BKKWilker, label: "BKK Wilker" },
                    ]}
                    onChange={(opt) => {
                      const val = opt ? opt.value : "";
                      handleInputChange({
                        preventDefault: () => {},
                        target: { name: "level", value: val },
                      });
                    }}
                    value={
                      [
                        { value: UserLevel.Fasyankes, label: "Fasyankes" },
                        { value: UserLevel.District, label: "Kabupaten/Kota" },
                        { value: UserLevel.Province, label: "Provinsi" },
                        { value: UserLevel.National, label: "Nasional/Pusat" },
                        { value: UserLevel.LabTier2, label: "Lab Tingkat 2" },
                        { value: UserLevel.LabTier3, label: "Lab Tingkat 3" },
                        { value: UserLevel.LabTier4, label: "Lab Tingkat 4" },
                        { value: UserLevel.LabTier5, label: "Lab Tingkat 5" },
                        { value: UserLevel.BKKInduk, label: "BKK Induk" },
                        { value: UserLevel.BKKWilker, label: "BKK Wilker" },
                      ].find((item) => item.value === values.level) || null
                    }
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <InputSelect
                    label="Hak Akses"
                    name="role"
                    placeholder="Pilih"
                    data={[
                      { value: UserRoles.Admin, label: "Administrator" },
                      { value: UserRoles.User, label: "Pengguna" },
                      { value: "Viewer", label: "Tamu" },
                    ]}
                    onChange={(opt) => {
                      const val = opt ? opt.value : "";
                      handleInputChange({
                        preventDefault: () => {},
                        target: { name: "role", value: val },
                      });
                    }}
                    value={
                      [
                        { value: UserRoles.Admin, label: "Administrator" },
                        { value: UserRoles.User, label: "Pengguna" },
                        { value: "Viewer", label: "Tamu" },
                      ].find((item) => item.value === values.role) || null
                    }
                  />
                </div>
                <div>
                  <Button onClick={onFilter} isPrimary>
                    Terapkan
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingLeft: "16px", paddingRight: "16px", marginBottom: "16px" }}>
            <div>
              <button
                className="btn btn-teal font-weight-bold"
                onClick={() => changeMode(PageMode.add)}
              >
                <PlusCircle className="mr-2" />
                Tambah Data
              </button>
            </div>
            <div style={{ width: "300px" }}>
              <input
                type="text"
                className="form-control bg-light"
                placeholder="Cari berdasarkan nama..."
                onChange={(e) => onSearch(e)}
              />
            </div>
          </div>
          <TableComponent
            loading={loading}
            data={data?.users}
            headers={[
              "Nama Pengguna",
              "Username",
              "Level",
              "Hak Akses",
              "Status",
            ]}
            headerStyles={{
              0: { width: "25%", whiteSpace: "nowrap" },
            }}
            cols={["first_name", "username", "level", "role", "is_active"]}
            btnEdit={{
              className: "btn btn-outline-primary btn-sm font-weight-bold mr-3",
              btnName: "Edit",
              onClick: onEdit,
            }}
            btnRemove={{
              className: "btn btn-outline-danger btn-sm font-weight-bold",
              btnName: "Hapus",
              onClick: onRemove,
            }}
            currentPage={data?.currentPage}
            total={data?.total}
            limit={data?.limit}
            nextPage={data?.nextPage}
            previousPage={data?.previousPag}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    );
  }
}

export default Table;
